"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _Bottom = _interopRequireDefault(require("../01_atoms/Bottom"));

var _Button = _interopRequireDefault(require("../01_atoms/Button"));

var _Container = _interopRequireDefault(require("../01_atoms/Container"));

var _TitleBlock = _interopRequireDefault(require("../01_atoms/TitleBlock"));

var _SeatMatrixAvailabilityLegend = _interopRequireDefault(require("../01_atoms/SeatMatrixAvailabilityLegend"));

var _SeatSelectionWidget = _interopRequireDefault(require("../02_molecules/SeatSelectionWidget"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

var withTranslatedPropsNames = function withTranslatedPropsNames(WrappedComponent) {
  return function (props) {
    var numberOfSeatsToSelect = props.numberOfPassengers,
        trip = props.trip,
        selectedTrip = props.selectedTrip;
    return /*#__PURE__*/_react["default"].createElement(WrappedComponent, _extends({}, props, {
      numberOfSeatsToSelect: numberOfSeatsToSelect,
      selectedTrip: trip || selectedTrip
    }));
  };
};

var withSeatSelectorProps = function withSeatSelectorProps(WrappedComponent) {
  return _react["default"].memo(function (props) {
    var sdk = props.sdk;
    var ComponentWithSeatSelectorProps = sdk.seats.withSeatSelectorProps(WrappedComponent);
    console.log('Sending props to withSeatSelectorProps() --> ', props);
    return /*#__PURE__*/_react["default"].createElement(ComponentWithSeatSelectorProps, props);
  });
}; // We cache the return value of withSeatSelectorProps() to avoid
// unmounting/remounting <WithSeatSelectorProps /> in loop


var wrappedCache = new Map();

var SeatSelector = _react["default"].memo(function (_ref) {
  var sdk = _ref.sdk,
      wrappedComponent = _ref.wrappedComponent,
      otherProps = _objectWithoutProperties(_ref, ["sdk", "wrappedComponent"]);

  console.log('Rendering: SeatSelector');
  var Wrapped = null;

  if (wrappedCache.has(wrappedComponent)) {
    Wrapped = wrappedCache.get(wrappedComponent);
  } else {
    Wrapped = sdk.seats.withSeatSelectorProps(wrappedComponent);
    wrappedCache.set(wrappedComponent, Wrapped);
  }

  return /*#__PURE__*/_react["default"].createElement(Wrapped, _extends({
    key: "wrapped-main-seats-sector-widget",
    sdk: sdk
  }, otherProps));
});

var MainSeatsSelectorWidget = function MainSeatsSelectorWidget(_ref2) {
  var numberOfFloors = _ref2.numberOfFloors,
      selectedFloor = _ref2.selectedFloor,
      onFloorChange = _ref2.onFloorChange,
      seatInfoByPrice = _ref2.seatInfoByPrice,
      seatMatrix = _ref2.seatMatrix,
      selectedSeats = _ref2.selectedSeats,
      seatsPendingHold = _ref2.seatsPendingHold,
      seatsPendingRelease = _ref2.seatsPendingRelease,
      _ref2$areSeatsPending = _ref2.areSeatsPendingValidation,
      areSeatsPendingValidation = _ref2$areSeatsPending === void 0 ? false : _ref2$areSeatsPending,
      onSeatToggle = _ref2.onSeatToggle,
      numberOfSeatsToSelect = _ref2.numberOfSeatsToSelect,
      seatPrices = _ref2.seatPrices,
      loading = _ref2.loading,
      seatsLeft = _ref2.seatsLeft,
      _ref2$onConfirm = _ref2.onConfirm,
      onConfirm = _ref2$onConfirm === void 0 ? function () {} : _ref2$onConfirm,
      translatorForNamespace = _ref2.sdk.i18n.translatorForNamespace;
  console.log('Rendering: MainSeatsSelectorWidget');
  var t = translatorForNamespace('GenericTripSeatSelectionPageUI');
  var title = t('{n} seat{s} left to select', {
    n: seatsLeft,
    s: seatsLeft > 1 ? 's' : ''
  });
  var subtitle = t('Click on an empty seat to select it');

  if (seatsLeft === 0) {
    title = t('All seats selected');
    subtitle = t('You can unselect seats by clicking on them');
  }

  return /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement(_TitleBlock["default"], {
    title: title,
    subtitle: subtitle
  }), /*#__PURE__*/_react["default"].createElement(_SeatMatrixAvailabilityLegend["default"], {
    translator: t
  }), /*#__PURE__*/_react["default"].createElement(_SeatSelectionWidget["default"], {
    numberOfFloors: numberOfFloors,
    selectedFloor: selectedFloor,
    onFloorChange: onFloorChange,
    seatInfoByPrice: seatInfoByPrice,
    seatMatrix: seatMatrix,
    selectedSeats: selectedSeats,
    seatsPendingHold: seatsPendingHold,
    seatsPendingRelease: seatsPendingRelease,
    onSeatToggle: onSeatToggle,
    numberOfSeatsToSelect: numberOfSeatsToSelect,
    seatPrices: seatPrices,
    translator: t,
    loading: loading
  }), /*#__PURE__*/_react["default"].createElement(_Bottom["default"], {
    noSpacer: true
  }, /*#__PURE__*/_react["default"].createElement(_Container["default"], null, /*#__PURE__*/_react["default"].createElement(_Button["default"], {
    onClick: function onClick() {
      onConfirm();
    },
    fluid: true,
    primary: true,
    disabled: areSeatsPendingValidation || seatsLeft !== 0
  }, areSeatsPendingValidation ? t('Checking seats availability...') : t('Book seats')))));
};

var WrappedMainSeatsSelectorWidget = function WrappedMainSeatsSelectorWidget(props) {
  return /*#__PURE__*/_react["default"].createElement(SeatSelector, _extends({
    wrappedComponent: MainSeatsSelectorWidget
  }, props));
};

var _default = WrappedMainSeatsSelectorWidget;
exports["default"] = _default;